import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import * as d3 from 'd3';

@Component({
    selector: 'ixgauge',
    templateUrl: './gauge.component.html',
    styleUrls: ['./gauge.component.scss',
        '../../../../node_modules/bootstrap/dist/css/bootstrap.css']
})
export class GaugeComponent implements OnInit{
    @ViewChild('gauge') private chartContainer: ElementRef;

    private margin: any = { top: 20, bottom: 20, left: 20, right: 20};
    private width: number;
    private height: number;
    arc2: any;
    interval: any;


    ngOnInit() {
        this.createChart();
    }

    createChart() {
      //  const me = this;
        const element = this.chartContainer.nativeElement;
        this.width = element.offsetWidth - this.margin.left - this.margin.right;
        this.height = element.offsetHeight - this.margin.top - this.margin.bottom;
        let tickFontSize = '16px';
        let ltGrayColor = '#c9c9c9';
        let drGrayColor = '#626262';
        let gaugeFontFamily = 'open_sans_condensed';
        let w = 385;
        let h = 350;

        const svg = d3.select(element)
            .append('svg')
            .attr('width', w)
            .attr('height', h);

        const arc = d3.arc()
            .innerRadius(115)
            .outerRadius(155)
            .startAngle(-2.5)
            .endAngle(2.5);

        const path = svg
            .append('path')
            .attr('id', 'bgPath')
            .attr('d', arc)
            .attr('stroke', ltGrayColor)
            .attr('stroke-width', 3)
            .attr('transform', 'translate(' + w / 2 + ',' + h / 2 + ')')
            .attr('fill', ltGrayColor);

        const percentText = svg
            .append('text')
            .attr('id', 'percentTxt')
            .attr('x', w/2)
            .attr('y', h/2+ 16)
            .attr('text-anchor', 'middle')
            .attr('font-size', '60px')
            .attr('font-family', gaugeFontFamily)
            .attr('fill', drGrayColor)
            .text('0');

        const throughputText = svg
            .append('text')
            .attr('x', w/2)
            .attr('y', h/1.23)
            .attr('text-anchor', 'middle')
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', '16px')
            .attr('fill', drGrayColor)
            .text('THROUGHPUT');

        const mbpsText = svg
            .append('text')
            .attr('x', w/2)
            .attr('y', h/1.15)
            .attr('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-style', 'italic')
            .attr('font-family', 'open_sans')
            .attr('font-size', '12px')
            .text('Mbps');

        const tick0 = svg
            .append('text')
            .attr('x', w/2.7)   //bigger number goes left; smaller number goes right
            .attr('y', h/1.4)   //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', tickFontSize)
            .text('0%');

        const tick1 = svg
            .append('text')
            .attr('x', w/3.6)  //bigger number goes left; smaller number goes right
            .attr('y', h/2)  //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', tickFontSize)
            .text('20%');

        const tick2 = svg
            .append('text')
            .attr('x', w/2.6)  //bigger number goes left; smaller number goes right
            .attr('y', h/3.5)  //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', tickFontSize)
            .text('40%');

        const tick3 = svg
            .append('text')
            .attr('x', w/1.6)  //bigger number goes left; smaller number goes right
            .attr('y', h/3.5)  //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', tickFontSize)
            .text('60%');

        const tick4 = svg
            .append('text')
            .attr('x', w/1.37)  //bigger number goes left; smaller number goes right
            .attr('y', h/2)  //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('fill', ltGrayColor)
            .attr('font-family', gaugeFontFamily)
            .attr('font-size', tickFontSize)
            .text('80%');

        const tick5 = svg
            .append('text')
            .attr('x', w/1.6)  //bigger number goes left; smaller number goes right
            .attr('y', h/1.4)  //bigger number goes up; smaller goes down
            .style('text-anchor', 'middle')
            .attr('font-family', gaugeFontFamily)
            .attr('fill', ltGrayColor)
            .attr('font-size', tickFontSize)
            .text('100%');

        // ***************************************************************************************************

        this.arc2 = d3.arc()
            .innerRadius(115)
            .outerRadius(155)
            .startAngle(-2.5);


        const path2 = svg
            .append('path')
            .datum({endAngle: -2.5})
            .attr('class', 'foreArc')
            .attr('stroke', '#31b4ce')
            .attr('stroke-width', 3)
            .attr('transform', 'translate(' + w / 2 + ',' + h / 2 + ')')
            .attr('fill', '#31b4ce')
            .attr('d', this.arc2);


          /*this.interval = setInterval(function() {
              me.animateGauge(me.getRandomInt(0, 100));
          }, 1500);*/

    }

    updateGauge(value: string) {
        const element = this.chartContainer.nativeElement;
        const percent = d3.select(element).select('#percentTxt');
        percent
            .text( value );

    }


    getRandomInt(min: number, max: number) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
    }


    animateGauge(percent: number) {
        let initVal = -2.5;
        const element = this.chartContainer.nativeElement;
        initVal = initVal + (.05 * percent);
        if( initVal > 2.5 ){
            initVal = 2.5;
        }
        const svg = d3.select(element).select('.foreArc')
            .transition()
            .duration(750)
            .attrTween('d', this.arcTween(initVal));
    }

    arcTween(newAngle: number) {
        const me = this;
        return function (d: any) {
            let interpolate = d3.interpolate(d.endAngle, newAngle);
            return function (t: any) {
                d.endAngle = interpolate(t);
                return me.arc2(d);
            };
        };
    }


}



// WEBPACK FOOTER //
// ./src/app/components/gauge/gauge.component.ts